export const ECW_PATTERN = 'ecw-service';
export const ECM_PATTERN = 'ecm-service';
export const CORRESPONDENCE_PATTERN = 'correspondence';
